export default {
  trip: {
    method: 'get',
    url: '/shared/trip/ID'
  }
}
